import { ImageComponent } from 'components/Image';
import { CommonUtilsContext } from 'contexts/commonUtils';

import { useTheme } from 'hooks/theme';
import type { FC } from 'react';
import { useCallback, useContext } from 'react';
import { Link } from 'react-navi';
import { ScLogo } from './styled';

interface LogoProps {
  height?: number;
  mobHeight?: number;
  smallLogo?: boolean;
  onClick?: () => void;
}

export const Logo: FC<LogoProps> = ({ smallLogo, onClick, ...props }) => {
  const { menu } = useTheme();
  const { brandAssetsData } = useContext(CommonUtilsContext);

  const defaultLogo = smallLogo ? (
    <menu.logoSmall.component />
  ) : (
    <menu.logo.component />
  );

  const getCmsLogo = useCallback(() => {
    if (!brandAssetsData) return;

    const logoFromCms = smallLogo
      ? brandAssetsData?.logoMobile?.url
      : brandAssetsData?.logoDesktop?.url;

    if (!logoFromCms) return;

    return brandAssetsData?.animatedLogo ? (
      <object
        aria-label="Lucky Elf"
        data={logoFromCms}
        height={smallLogo ? '100%' : 34}
        width={smallLogo ? 48 : '100%'}
      />
    ) : (
      <ImageComponent
        alt="Lucky Elf"
        height={smallLogo ? '100%' : 34}
        src={logoFromCms}
        width={smallLogo ? 48 : '100%'}
      />
    );
  }, [brandAssetsData, smallLogo]);

  return (
    <ScLogo {...props}>
      <Link className="logo" href="/" onClick={onClick}>
        {getCmsLogo() || defaultLogo}
      </Link>
    </ScLogo>
  );
};
